import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatMoney } from '@tcrd/shared';
import { Card, EmptyState, Skeleton, Stat } from '@tcrd/ui';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { Page } from '../../../components/Page';
import { api } from '../../../lib/api';
import { fmtDateTime } from '../../../lib/format';

interface Tips {
  total: string;
  items: Array<{ id: string; amount: string; method: string; receivedAt: string; ride: { code: string; id: string } | null }>;
}

const RANGES = {
  week: () => new Date(Date.now() - 7 * 86_400_000),
  month: () => new Date(Date.now() - 30 * 86_400_000),
  year: () => new Date(Date.now() - 365 * 86_400_000),
};

export function TipsPage() {
  const [range, setRange] = useState<keyof typeof RANGES>('month');
  const q = useQuery({ queryKey: ['tips', range], queryFn: () => api<Tips>('/tips', { query: { from: RANGES[range]().toISOString() } }) });
  return (
    <Page title="Propinas" back="/driver/more" onRefresh={() => q.refetch()}>
      <div className="flex flex-col gap-4">
        <IonSegment value={range} onIonChange={(e) => setRange(e.detail.value as keyof typeof RANGES)}>
          <IonSegmentButton value="week"><IonLabel>7 días</IonLabel></IonSegmentButton>
          <IonSegmentButton value="month"><IonLabel>30 días</IonLabel></IonSegmentButton>
          <IonSegmentButton value="year"><IonLabel>12 meses</IonLabel></IonSegmentButton>
        </IonSegment>
        {q.isLoading && <Skeleton className="h-24" />}
        {q.data && <Stat label="Total en propinas" value={formatMoney(q.data.total)} tone="accent" hint="Solo propinas registradas como recibidas" />}
        {q.data?.items.length === 0 && <EmptyState title="Sin propinas en este período" />}
        <Card className="divide-y divide-[var(--border)]">
          {q.data?.items.map((t) => (
            <div key={t.id} className="px-4 py-3 flex justify-between text-sm">
              <span>{t.ride?.code ?? '—'} · {t.method === 'CASH' ? 'Efectivo' : 'Transferencia'}<span className="block text-xs text-[var(--text-muted)]">{fmtDateTime(t.receivedAt)}</span></span>
              <span className="font-semibold tabular-nums">{formatMoney(t.amount)}</span>
            </div>
          ))}
        </Card>
      </div>
    </Page>
  );
}
